var render, staticRenderFns
import script from "./CAutocomplete.vue?vue&type=script&lang=ts"
export * from "./CAutocomplete.vue?vue&type=script&lang=ts"
import style0 from "./CAutocomplete.vue?vue&type=style&index=0&id=ff27391e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff27391e",
  null
  
)

export default component.exports